export default {
  default: () => import("/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/layouts/default.vue").then(m => m.default || m),
  simple: () => import("/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/layouts/simple.vue").then(m => m.default || m)
}